/**
 * Created by fers on 15/01/2017.
 */
/* eslint react/jsx-sort-props: 0 */
import React from 'react';
import PropTypes from 'prop-types';

interface MiniLogoProps {
    className?: string;
    color?: boolean;
    height?: string;
    width?: string;
}

export default class MiniLogo extends React.Component<MiniLogoProps> {
    static propTypes = {
        className: PropTypes.string,
        color: PropTypes.bool,
        height: PropTypes.string,
        width: PropTypes.string,
    };

    render() {
        if (this.props.color) {
            return (
                <svg className={this.props.className} height={this.props.width ? null : (this.props.height ? this.props.height : "100%")}
                     width={this.props.width} viewBox="0 0 600 644.5" enableBackground="new 0 0 600 644.5"
                     version="1.1">
                    <g>
                        <polygon fill="#B08111"
                                 points="245.026,292.847 205.945,270.039 205.875,440.189 300.236,494.5 300.236,449.787 245.026,418.231"/>
                        <polygon fill="#B08111"
                                 points="261.076,302.219 261.221,343.502 300.236,365.092 300.236,325.058"/>
                        <polygon fill="#B08111" points="150,409.065 189.071,431.92 189.071,260.2 150,237.391"/>
                        <polygon fill="#B08111" points="261.067,408.33 300.236,430.107 300.236,385.33 261.035,363.408"/>
                    </g>
                    <g>
                        <polygon fill="#DBA40D"
                                 points="394.869,269.847 355.565,292.782 355.565,333.727 394.869,310.972 "/>
                        <polygon fill="#DBA40D"
                                 points="339.259,302.283 300.236,325.058 300.236,365.092 339.28,342.844 "/>
                        <polygon fill="#DBA40D" points="300.236,494.5 450,407.11 450,362.35 300.236,449.787 "/>
                        <polygon fill="#DBA40D"
                                 points="410.671,260.617 410.671,321.163 300.236,385.33 300.236,430.107 450,343.053 450,237.671 "/>
                    </g>
                    <g>
                        <polygon fillRule="evenodd" clipRule="evenodd" fill="#F3C034"
                                 points="261.076,302.219 300.236,325.058 339.259,302.283 300.865,279.784 	"/>
                        <polygon fillRule="evenodd" clipRule="evenodd" fill="#F3C034"
                                 points="245.026,247.153 205.945,270.039 245.026,292.847 284.959,270.039 	"/>
                        <polygon fillRule="evenodd" clipRule="evenodd" fill="#F3C034"
                                 points="299.763,150 260.667,172.821 410.671,260.617 450,237.671 	"/>
                        <polygon fillRule="evenodd" clipRule="evenodd" fill="#F3C034"
                                 points="150,237.391 189.071,260.2 244.452,227.662 355.565,292.782 394.869,269.847 244.665,182.085 	"/>
                    </g>
                </svg>
            );
        } else {
            return (
                <svg height={this.props.width ? null : (this.props.height ? this.props.height : "100%")} width={this.props.width} viewBox="0 0 600 644.5" enableBackground="new 0 0 600 644.5" version="1.1">
                    <g>
                        <polygon fill="#FFFFFF" points="245.026,292.847 205.945,270.039 205.875,440.189 300.236,494.5 300.236,449.787 245.026,418.231"/>
                        <polygon fill="#FFFFFF" points="261.076,302.219 261.221,343.502 300.236,365.092 300.236,325.058 "/>
                        <polygon fill="#FFFFFF" points="150,409.065 189.071,431.92 189.071,260.2 150,237.391 "/>
                        <polygon fill="#FFFFFF" points="261.067,408.33 300.236,430.107 300.236,385.33 261.035,363.408 "/>
                    </g>
                    <g>
                        <polygon fill="#FFFFFF" points="394.869,269.847 355.565,292.782 355.565,333.727 394.869,310.972 "/>
                        <polygon fill="#FFFFFF" points="339.259,302.283 300.236,325.058 300.236,365.092 339.28,342.844 "/>
                        <polygon fill="#FFFFFF" points="300.236,494.5 450,407.11 450,362.35 300.236,449.787 "/>
                        <polygon fill="#FFFFFF" points="410.671,260.617 410.671,321.163 300.236,385.33 300.236,430.107 450,343.053 450,237.671 "/>
                    </g>
                    <g>
                        <polygon fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" points="261.076,302.219 300.236,325.058 339.259,302.283 300.865,279.784 "/>
                        <polygon fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" points="245.026,247.153 205.945,270.039 245.026,292.847 284.959,270.039 "/>
                        <polygon fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" points="299.763,150 260.667,172.821 410.671,260.617 450,237.671 "/>
                        <polygon fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" points="150,237.391 189.071,260.2 244.452,227.662 355.565,292.782 394.869,269.847 244.665,182.085 "/>
                    </g>
                </svg>
            );
        }
    }
}

